export default "__VITE_ASSET__Cfy2pldc__"